import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" {...props}><path fill="#FFF" d="M2.597 0L.649 4.977v20.344h6.925V29h3.896l3.679-3.68h5.627l7.575-7.574V0H2.597zm23.156 16.448l-4.328 4.328H14.5l-3.68 3.68v-3.68H4.978V2.596h20.776v13.852zm-4.328-8.873v7.567h-2.597V7.575h2.597zm-6.925 0v7.567h-2.597V7.575H14.5z" /></svg>);